<template>
  <div @click="handleClick($event.target)">
    <a v-if="isExternalLink" :href="url" :class="classList">
      <i :class="classIcon"/>
      {{ name }}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
    </a>
    <router-link v-else :to="url" :class="classList">
      <i :class="classIcon"/>
      {{ name }}
      <b-badge v-if="badge && badge.text" :variant="badge.variant">{{ badge.text }}</b-badge>
    </router-link>
  </div>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      default: ""
    },
    url: {
      type: String,
      default: ""
    },
    icon: {
      type: String,
      default: ""
    },
    badge: {
      type: Object,
      default: () => {}
    },
    variant: {
      type: String,
      default: ""
    },
    classes: {
      type: String,
      default: ""
    }
  },
  computed: {
    classList() {
      return ["nav-link", this.linkVariant, ...this.itemClasses];
    },
    classIcon() {
      return ["nav-icon", this.icon];
    },
    linkVariant() {
      return this.variant ? `nav-link-${this.variant}` : "";
    },
    itemClasses() {
      return this.classes ? this.classes.split(" ") : [];
    },
    isExternalLink() {
      if (this.url.substring(0, 4) === "http") {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    handleClick(e) {
      let target = e.parentElement.parentElement.parentElement.parentElement;
      let navs = target.parentElement.childNodes;
      for(var i = 0; i < navs.length; i++) {
        if (navs[i] != target) {
          navs[i].classList.remove('open');
        }
      }
    }
  }
};
</script>
